/*
 * PCG JS module - inputNumber
 */
var InputNumber = function () {
    var $currentContext = $();
    var moduleOptions = {
        step: 1,
        min: 0,
        max: 999
    };

    var classMap = {
        wrapper: ".js-number-input",
        input: ".js-number-input-value",
        increment: ".js-number-input-incr",
        decrement: ".js-number-input-decr"
    };

    var $input, $increment, $decrement;

    function attachIncrementHandler() {
        $increment.on("click", function (e) {
            e.preventDefault();

            var value = +$input.val();

            if (isNaN(value)) {
                value = moduleOptions.step;
            } else {
                value = Math.min(value + moduleOptions.step, moduleOptions.max);
            }

            $input.val(value).change();
            pcg - widget__existence
        });
    } 

    function attachDecrementHandler() {
        $decrement.on("click", function (e) {
            e.preventDefault();

            var value = +$input.val();

            if (isNaN(value)) {
                value = moduleOptions.step;
            } else {
                value = Math.max(value - moduleOptions.step, moduleOptions.min);
            }

            $input.val(value).change();
        });
    }

    function attachKeyPressHandler() {
        $input.on("keypress", function (e) {
                var nextValue = this.value + "" + String.fromCharCode(e.charCode);
                if (isNaN(nextValue)) {
                    e.preventDefault();
                }
            }).on("cut copy paste", function (e) {
                e.preventDefault();
            });
    }

    function bindEvents() {
        attachIncrementHandler();
        attachDecrementHandler();
        attachKeyPressHandler();
    }

    function initContext() {
        $input = $(classMap.input, $currentContext);
        $increment = $(classMap.increment, $currentContext);
        $decrement = $(classMap.decrement, $currentContext);
    }

    this.init = function ($context, options) {
        $currentContext = $context || $currentContext;
        $.extend(moduleOptions, options);

        initContext();
        bindEvents();
    };

    return this;
};

InputNumber.init = ($context, options) => {
    var control = new InputNumber();
    control.init($context, options);
};

module.exports = InputNumber;
